import React from 'react'
import PropTypes from 'prop-types'
import withStickiness from 'shared/hocs/withStickiness'
import { CloseButton } from 'shared/UI/CloseButton'
import { GreetingText, GreetingTitle } from 'LiveBoard/components/shared/GreetingCard'
import { ACCESSIBILITY_CLASSES, TAB_INDEXES, triggerClickOnEnter } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

class GreetingCard extends React.Component  {
  componentWillUnmount() {
    const { onClose, provideStickyContainer } = this.props
    onClose && onClose()
    provideStickyContainer && provideStickyContainer(null)
  }

  stopPropagation = (e) => e.stopPropagation()

  render() {
    const { config, hasSellerCard, provideStickyContainer, onClose, lead } = this.props

    return config.show && (
      <div
        className={`greeting-card-wrapper ${hasSellerCard ? 'with-seller-card': ''} ${ACCESSIBILITY_CLASSES.main}`}
        onClick={this.stopPropagation}
        ref={provideStickyContainer}>
        <span className="greeting-card-overlay" onClick={onClose} onKeyDown={triggerClickOnEnter}/>
        <div className="greeting-card-container">
          <GreetingText lead={lead} config={config} />
          <div className="greeting-card-content">
            {config.show_title && <GreetingTitle lead={lead} config={config} />}
            <p>{config.text}</p>
            <CloseButton onClose={onClose} tabIndex={TAB_INDEXES.GreetingCardCloseButton}/>
          </div>
        </div>
      </div>
    )
  }
}

GreetingCard.propTypes = {
  lead: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  provideStickyContainer: PropTypes.func,
  hasSellerCard: PropTypes.bool.isRequired
}

export default withStickiness(GreetingCard)
